import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./outline/board-members.svg";
var BoardMembersOutline_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  BoardMembersOutline_default as default
};
